import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

//bootstrap vue
import { BootstrapVue } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

//perfect scrollbar
import PerfectScrollbar from 'vue2-perfect-scrollbar';
Vue.use(PerfectScrollbar);

//vue-scrollactive
import VueScrollactive from 'vue-scrollactive';
Vue.use(VueScrollactive);

import { BootstrapVueIcons } from 'bootstrap-vue'
Vue.use(BootstrapVueIcons)

//Sesion variables
import VueSession from 'vue-session'
Vue.use(VueSession);

//vue-meta
import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
});

//Sweetalert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
const options = {
    confirmButtonColor: '#4361ee',
    cancelButtonColor: '#e7515a'
};
Vue.use(VueSweetalert2, options);

//portal vue
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

//vue-i18n
import i18n from './i18n';

Vue.config.productionTip = false;

require('./vee-validate');

// set default settings
import appSetting from './app-setting';
Vue.prototype.$appSetting = appSetting;
appSetting.init();

restoreSession()

function restoreSession () {

    // const self = Vue.prototype
    const loggedIn = Vue.prototype.$session.get('user_id') !== undefined ? true : false
    if (loggedIn) {
  
      store.commit('saveLoggedState', true)
      store.commit('saveLoginTokenState', Vue.prototype.$session.get('user_token'))
      store.commit('saveLoginNameState', Vue.prototype.$session.get('user_name'))
      store.commit('saveLoginPerfilState', Vue.prototype.$session.get('user_perfil'))
      store.commit('saveOpcionesMenu', Vue.prototype.$session.get('user_menus'))     
      store.commit('savePermisosOpcionMenu', Vue.prototype.$session.get('user_permisos'))    
      store.commit('saveLoginIdState', Vue.prototype.$session.get('user_id'))
      store.commit('saveLoginIdEmpresaState', Vue.prototype.$session.get('user_empresa_id'))
      store.commit('saveLoginEmpresaState', Vue.prototype.$session.get('user_empresa'))
            
  
      console.log('restoreSesion')
    }else{
      //this.$store.commit('global/savecolorappState', 0)
    }
  }

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
